import api from "./api";

/** Poll interval for kiosk-originated TMAX jobs (ms). */
export const SUNBED_TMAX_JOB_POLL_MS = 5000;

export interface PendingSunbedTmaxJob {
  id: number;
  sunbed_session_id: number;
  tmax_id: number;
  minutes: number;
  delay: number;
}

export async function fetchPendingSunbedTmaxJob(): Promise<{
  job: PendingSunbedTmaxJob | null;
}> {
  const res = await api.get("/admin/sunbed-tmax-jobs/pending");
  const payload = res.data?.data ?? res.data;
  const job = payload?.job;
  if (!job) {
    return { job: null };
  }
  return {
    job: {
      id: Number(job.id),
      sunbed_session_id: Number(job.sunbed_session_id),
      tmax_id: Number(job.tmax_id),
      minutes: Number(job.minutes),
      delay: Number(job.delay ?? 0),
    },
  };
}

export async function completeSunbedTmaxJob(id: number): Promise<void> {
  await api.post(`/admin/sunbed-tmax-jobs/${id}/complete`);
}

export async function failSunbedTmaxJob(id: number, message?: string): Promise<void> {
  await api.post(`/admin/sunbed-tmax-jobs/${id}/fail`, {
    ...(message ? { message } : {}),
  });
}
